import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'

import VueMaterial from 'vue-material'
// import { MdField, MdInput, MdTextarea, MdSelect } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

Vue.use(VueResource)
Vue.use(VueMaterial)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
